
export type ColorPalette = {
  PRIMARY: string;
  PRIMARY_LIGHT: string;
  BLOG_PRIMARY_BACKGROUND: string;
  PRIMARY_DARK: string;
  SECONDARY: string;
  TEXT: string;
  BACKGROUND: string;
  HOVER_LIGHT: string;
};

export const COLORS: ColorPalette = {
  PRIMARY: '#764ba2ff',
  PRIMARY_LIGHT: '#c2a3e2',
  BLOG_PRIMARY_BACKGROUND: '#c4b3d8ff',
  PRIMARY_DARK: '#5a3a7e',
  SECONDARY: '#4263eb',
  TEXT: '#333333',
  BACKGROUND: '#ffffff',
  HOVER_LIGHT: '#a566cdff'
};